module.exports = __webpack_public_path__ + "static/media/subtitle_user.61dbb6d9.svg";